// extracted by mini-css-extract-plugin
export var container = "LeiaMais-module--container--jnK+x";
export var extraContent = "LeiaMais-module--extra-content--durDA";
export var readMoreLink = "LeiaMais-module--read-more-link--q7BD-";